/* eslint-disable no-magic-numbers */

function setCanvasDimensions(canvas, srcOrientation, height, width) {
  if (srcOrientation > 4 && srcOrientation < 9) {
    canvas.width = height;
    canvas.height = width;
  } else {
    canvas.width = width;
    canvas.height = height;
  }
}

export default function resetOrientation(srcBase64, srcOrientation, callback) {
  const img = new Image();

  img.onload = function () {
    const width = img.width;
    const height = img.height;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    setCanvasDimensions(canvas, srcOrientation, height, width);

    switch (srcOrientation) {
    case 2:
      ctx.transform(-1, 0, 0, 1, width, 0);
      break;
    case 3:
      ctx.transform(-1, 0, 0, -1, width, height);
      break;
    case 4:
      ctx.transform(1, 0, 0, -1, 0, height);
      break;
    case 5:
      ctx.transform(0, 1, 1, 0, 0, 0);
      break;
    case 6:
      ctx.transform(0, 1, -1, 0, height, 0);
      break;
    case 7:
      ctx.transform(0, -1, -1, 0, height, width);
      break;
    case 8:
      ctx.transform(0, -1, 1, 0, 0, width);
      break;
    default: break;
    }

    ctx.drawImage(img, 0, 0);
    callback(canvas.toDataURL());
  };

  img.src = srcBase64;
}
